import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

export function IconClapperboard({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <rect x="2" y="8" width="20" height="14" rx="3" fill="#b8a5f0" stroke="#000" strokeWidth="2.2" />
      <path d="M2 11h20" stroke="#000" strokeWidth="1.5" />
      <path d="M5 2L9 8" stroke="#000" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M10 2L14 8" stroke="#000" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M15 2L19 8" stroke="#000" strokeWidth="2.2" strokeLinecap="round" />
      <rect x="2" y="2" width="20" height="6" rx="2" fill="#fff" stroke="#000" strokeWidth="2.2" />
    </svg>
  );
}

export function IconSparkleWand({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <line x1="4" y1="20" x2="15" y2="9" stroke="#000" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="16" cy="8" r="2.5" fill="#b8a5f0" stroke="#000" strokeWidth="2" />
      <path d="M18 2v3" stroke="#000" strokeWidth="2" strokeLinecap="round" />
      <path d="M21 5h-3" stroke="#000" strokeWidth="2" strokeLinecap="round" />
      <path d="M10 3l.7 1.5L12 5l-1.3.5L10 7l-.7-1.5L8 5l1.3-.5L10 3z" fill="#7c5cbf" stroke="#000" strokeWidth="1" />
    </svg>
  );
}

export function IconPaintbrush({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <path d="M14 3c3-1 7 2 7 5s-4 5-7 7c-1 1-2 2-2 4v2a2 2 0 01-2 2H8a2 2 0 01-2-2v-2c0-2-1-3-2-4" fill="#b8a5f0" stroke="#000" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="11" cy="8" r="1.5" fill="#7c5cbf" />
      <circle cx="15" cy="7" r="1" fill="#000" />
      <circle cx="13" cy="11" r="1" fill="#000" />
    </svg>
  );
}

export function IconPencilSquiggle({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z" fill="#fff" stroke="#000" strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M14 6l3 3" stroke="#000" strokeWidth="2" strokeLinecap="round" />
      <path d="M4 20h3" stroke="#b8a5f0" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconFilmPlay({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <rect x="2" y="3" width="20" height="18" rx="3" fill="#7c5cbf" stroke="#000" strokeWidth="2.2" />
      <rect x="4" y="5" width="3" height="3" rx="1" fill="#000" />
      <rect x="4" y="14" width="3" height="3" rx="1" fill="#000" />
      <rect x="17" y="5" width="3" height="3" rx="1" fill="#000" />
      <rect x="17" y="14" width="3" height="3" rx="1" fill="#000" />
      <path d="M10 8.5v7l5.5-3.5L10 8.5z" fill="#b8a5f0" stroke="#000" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}

export function IconPlayBounce({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <circle cx="12" cy="12" r="10" fill="#b8a5f0" stroke="#000" strokeWidth="2.2" />
      <path d="M9.5 7.5v9l7-4.5-7-4.5z" fill="#000" />
      <path d="M5 3l1 2" stroke="#7c5cbf" strokeWidth="2" strokeLinecap="round" />
      <path d="M19 3l-1 2" stroke="#7c5cbf" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconStarBurst({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <path d="M12 2l2.1 6.5H21l-5.5 4 2.1 6.5L12 15l-5.6 4 2.1-6.5L3 8.5h6.9L12 2z" fill="#b8a5f0" stroke="#000" strokeWidth="2" strokeLinejoin="round" />
      <circle cx="12" cy="11" r="2" fill="#7c5cbf" />
    </svg>
  );
}

export function IconHome({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <path d="M3 12l9-8 9 8" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 10v9a2 2 0 002 2h10a2 2 0 002-2v-9" fill="#b8a5f0" stroke="#000" strokeWidth="2.2" />
      <rect x="9" y="15" width="6" height="6" rx="1" fill="#7c5cbf" stroke="#000" strokeWidth="1.5" />
    </svg>
  );
}

export function IconCompass({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <circle cx="12" cy="12" r="10" fill="#fff" stroke="#000" strokeWidth="2.2" />
      <polygon points="16,6 14,14 6,16 10,10" fill="#b8a5f0" stroke="#000" strokeWidth="1.5" />
      <polygon points="10,10 14,14 16,6" fill="#7c5cbf" />
      <circle cx="12" cy="12" r="1.5" fill="#000" />
    </svg>
  );
}

export function IconFolder({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <path d="M2 7a2 2 0 012-2h5l2 3h9a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V7z" fill="#b8a5f0" stroke="#000" strokeWidth="2.2" />
      <path d="M2 10h20" stroke="#000" strokeWidth="1.5" />
      <circle cx="12" cy="15" r="2" fill="#7c5cbf" stroke="#000" strokeWidth="1.2" />
    </svg>
  );
}

export function IconCoin({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <circle cx="12" cy="12" r="10" fill="#e8923e" stroke="#c47520" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="7.8" fill="#2a2a2a" stroke="#1a1a1a" strokeWidth="1.2" />
      <text x="12" y="16.2" textAnchor="middle" fontSize="11" fontWeight="900" fontFamily="sans-serif" fill="#e8923e">T</text>
    </svg>
  );
}

export function IconHeart({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <path d="M12 21s-8-5.5-8-11a4.5 4.5 0 019 0 4.5 4.5 0 019 0c0 5.5-8 11-8 11z" fill="#b8a5f0" stroke="#000" strokeWidth="2.2" />
    </svg>
  );
}

export function IconLifebuoy({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <circle cx="12" cy="12" r="10" fill="#fff" stroke="#000" strokeWidth="2.2" />
      <circle cx="12" cy="12" r="4" fill="#b8a5f0" stroke="#000" strokeWidth="2" />
      <path d="M4.9 4.9l3.6 3.6M15.5 15.5l3.6 3.6M4.9 19.1l3.6-3.6M15.5 8.5l3.6-3.6" stroke="#7c5cbf" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconTrendUp({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <path d="M4 18l5-5 3 3 7-9" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 7h5v5" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconHeartSmall({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn("size-5", className)}>
      <path d="M12 21s-8-5.5-8-11a4.5 4.5 0 019 0 4.5 4.5 0 019 0c0 5.5-8 11-8 11z" fill="#b8a5f0" stroke="#000" strokeWidth="2" />
    </svg>
  );
}
